// @flow

import * as actions from './Residents.actionTypes'

const initialState = {
  listInitiated: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.RESIDENTS_LIST_READY:
      return {
        ...state,
        listInitiated: true,
      }
    default:
      return state
  }
}
